import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ScaleType } from '@swimlane/ngx-charts';
import { IPieChartItem } from 'src/app/app.types';

@Component({
    selector: 'users-chart',
    templateUrl: './users-chart.component.html',
    styleUrls: ['./users-chart.component.scss'],
    standalone: false
})
export class UsersChartComponent implements OnChanges {
    ngOnChanges(changes: SimpleChanges): void {
      if (changes['groupedPieData'] && this.groupedPieData) {
        this.pieData = Object.values(this.groupedPieData).flat();
        this.customColorsSchema.domain = this.pieData.map(item => item.color);
      }
    }
    
    @Input() showLegend = false;
    
    @Input() currentUsersCount = 0;
    @Input() groupedPieData?: { [group: string]: IPieChartItem[] };

    public get flattenedPieData() : IPieChartItem[] {
      return this.groupedPieData !== undefined ? 
        Object.entries(this.groupedPieData).map(group => {
          return group[1].map(item => ({...item, name: group[0]}));
        }).flat() : [];
    }

    
    public get totalUsersCount() : number {
      return this.pieData.reduce((acc, item) => acc + item.value, 0);
    }
    
    
    pieData: IPieChartItem[] = [];

    customColorsSchema = {
            name: "customScheme",
            selectable: true,
            group: ScaleType.Ordinal,
            domain: []
        };

}
